/* global u, initAnimate */
/* eslint complexity: [1, 20] */
import easeInOutQuad from '../../_patterns/00-base/global/utils/ease-in-out-quad';

export default (scroll_machine, documentScroller) => {


  const curtainSettings = window.curtainSettings;
  curtainSettings.stickyElement = document.querySelector('.sticky-under-curtain');


  if (!(curtainSettings && curtainSettings.curtainEl  && curtainSettings.stickyElement)) {
    documentScroller.scrollUpdateChecker.setScrollUpdateAllowed(true);
    return null;
  }

  const btn_scroll_down = document.querySelector('.js-hero__scroll-down');
  

  const main_content = document.querySelector('main h1');

  // initialize animation function with easing
  const animate = initAnimate(easeInOutQuad);


  /**
   * animated scrolling function with a fallback for browsers that do not support scroll-behavior
   * @param  {[number]} y value to scroll to
   */
  function scrollTo(y) {
    animate(500, scroll_machine.scrollY, y, value => {
      window.scrollTo(0, value);
    });
  }

  function raise() {
    scrollTo(window.curtainSettings.curtainEl.getBoundingClientRect().height);
  }

  function lower() {
    scrollTo(0);
  }

  setTimeout(() => documentScroller.scrollUpdateChecker.setScrollUpdateAllowed(true), 10);


  btn_scroll_down.addEventListener('click', e => {
    e.preventDefault();
      if (main_content) {
        main_content.focus();
      }
      raise();
  });

  return {
    raise: raise,
    lower: lower
  }
};
